"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var makeStyles_1 = require("../../../theme/makeStyles");
exports.default = (0, makeStyles_1.makeStyles)(function (theme) { return ({
    root: {
        display: 'flex',
        flexDirection: 'column',
        alignContent: 'center',
        background: theme.colors.white,
        transition: 'all 0.2s ease-in-out',
        '&:focus-within': {
            borderColor: theme.colors.gray500
        }
    },
    disabled: {
        cursor: 'not-allowed',
        '& $input': {
            color: theme.colors.gray300,
            background: 0
        },
        '& $label': {
            color: theme.colors.gray300
        }
    },
    focused: {
        borderColor: theme.colors.gray500
    },
    errorHelp: {
        display: 'flex',
        alignSelf: 'flex-start',
        justifyContent: 'start',
        marginTop: theme.spacing('small'),
        '& svg': {
            '&:first-child': {
                alignSelf: 'flex-start',
                flexShrink: '0',
                marginTop: '2px'
            }
        }
    },
    errorHelpText: {
        marginLeft: '4px'
    },
    field: {
        display: 'flex',
        alignItems: 'stretch',
        alignContent: 'center',
        padding: [theme.spacing('small'), '12px'],
        minHeight: '48px',
        border: "1px solid ".concat(theme.colors.gray300),
        borderRadius: '4px',
        '&:focus-within': {
            outline: "2px solid ".concat(theme.colors.gray500),
            outlineOffset: '-1px'
        }
    },
    error: {
        borderColor: theme.colors.warningAccessible,
        outline: "2px solid ".concat(theme.colors.warningAccessible),
        outlineOffset: '-1px'
    },
    labelWrapper: {
        display: 'flex',
        alignItems: 'center',
        paddingBottom: '4px'
    },
    help: {
        paddingTop: '4px'
    },
    input: {
        flexGrow: 1,
        padding: 0,
        width: '100%',
        color: theme.colors.gray500,
        fontFamily: theme.typography.fontFamily.sansSerif,
        fontWeight: theme.typography.fontWeight.medium,
        // Note: Font size should map to <UtilityText size="medium" />
        fontSize: '16px',
        lineHeight: '28px',
        textOverflow: 'ellipsis',
        border: 0,
        outline: 'none',
        '&:disabled': {
            cursor: 'not-allowed'
        },
        '&::placeholder': {
            color: theme.colors.gray400
        }
    },
    inputPrefix: {
        paddingLeft: '12px'
    },
    inputSuffix: {
        paddingRight: '12px'
    },
    adornment: {
        lineHeight: '30px'
    }
}); });
